const dev = {
  websiteUrl: `http://localhost:5173`,
  apiUrl: `http://localhost:3000`,
  appMode: 'development',
  scriptsDocUrl: 'https://test.scripts.doc.pyxiscience.com/',
};

const test = {
  websiteUrl: `https://test.app.pyxiscience.com`,
  apiUrl: `https://test.api.pyxiscience.fr`,
  appMode: 'test',
  scriptsDocUrl: 'https://test.scripts.doc.pyxiscience.com/',
};

const staging = {
  websiteUrl: `https://staging.app.pyxiscience.com`,
  apiUrl: `https://staging.api.pyxiscience.fr`,
  appMode: 'staging',
  scriptsDocUrl: 'https://staging.scripts.doc.pyxiscience.com/',
};

const production = {
  websiteUrl: `https://app.pyxiscience.com`,
  apiUrl: `https://api.pyxiscience.fr`,
  appMode: 'production',
  scriptsDocUrl: 'https://scripts.doc.pyxiscience.com/',
};

type Environment = 'development' | 'test' | 'staging' | 'production';

const getEnvironment = () => {
  const appMode = process.env.NEXT_PUBLIC_APP_MODE as Environment;

  switch (appMode) {
    case 'production':
      return production;
    case 'staging':
      return staging;
    case 'test':
      return test;
    case 'development':
    default:
      return dev;
  }
};

export default getEnvironment;
